import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const NavItem = ({ slug, title }) => {
  return (
    <li className="inline-block mr-5 last:mr-0 py-1">
      <Link href="/blog/category/[slug]" as={`/blog/category/${slug}`}>
        <span className="text-[15px] text-[#9b9c9e] hover:text-[#4ecdc4b3] active:text-[#4ecdc4b3]">
          {title}
        </span>
      </Link>
    </li>
  );
};

const ArticlesSubHeader = ({ categories }) => {
  const { edges } = categories;
  const items = edges.map((edge) => {
    return (
      <NavItem
        key={edge.node.id}
        slug={edge.node.slug}
        title={edge.node.name}
      />
    );
  });

  return (
    <div className="bg-[#F7F7F7] w-full border-b border-[#d8d8d8] px-[26px]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="flex w-full mx-auto items-center">
          <div className="flex items-center h-full mr-[26px]">
            <Link href="/blog">
              <Image
                src="/images/Blog.png"
                width={50}
                height={23}
                alt="Blog Logo"
              />
            </Link>
          </div>
          <ul className="flex-1 list-none text-[0px] py-4 m-0">{items}</ul>
        </div>
      </div>
    </div>
  );
};

export default ArticlesSubHeader;
